import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=13c4f188&scoped=true"
import script from "./ProjectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectDialog.vue?vue&type=style&index=0&id=13c4f188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4f188",
  null
  
)

export default component.exports